"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormDialogServiceProvider = exports.useFormDialog = void 0;
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const utils_1 = require("../../../utils");
const styles_1 = require("../../../styles");
function a(formComponent, disableClosingByClickingOutside, autoHeight, minWidth, dialogClasses) {
    return Promise.reject();
}
const FormDialogServiceContext = react_1.default.createContext(Promise.reject);
const useFormDialog = () => react_1.default.useContext(FormDialogServiceContext);
exports.useFormDialog = useFormDialog;
const FormDialogServiceProvider = ({ children }) => {
    const backdropClasses = (0, utils_1.useBackdropStyles)();
    const [Form, setForm] = react_1.default.useState(null);
    const [isAutoHeight, setIsAutoHeight] = react_1.default.useState(false);
    const [minWidth, setMinWidth] = react_1.default.useState(500);
    const [disableClosingByClickingOutside, setDisableClosingByClickingOutside] = react_1.default.useState(false);
    const [dialogClasses, setDialogClasses] = react_1.default.useState();
    const awaitingPromiseRef = react_1.default.useRef();
    const openFormDialog = (formComponent, disableClosingByClickingOutside, autoHeight, width, dialogClasses) => {
        if (disableClosingByClickingOutside)
            setDisableClosingByClickingOutside(true);
        formComponent && setForm(() => formComponent);
        autoHeight && setIsAutoHeight(autoHeight);
        width && setMinWidth(width);
        dialogClasses && setDialogClasses(dialogClasses);
        return new Promise((resolve, reject) => {
            awaitingPromiseRef.current = { resolve, reject };
        });
    };
    const setDefault = () => {
        setForm(null);
        setIsAutoHeight(false);
        setMinWidth(500);
    };
    const handleClose = () => {
        var _a;
        (_a = awaitingPromiseRef.current) === null || _a === void 0 ? void 0 : _a.reject();
        setDisableClosingByClickingOutside(false);
        setDefault();
    };
    const handleSubmit = (result) => {
        var _a;
        (_a = awaitingPromiseRef.current) === null || _a === void 0 ? void 0 : _a.resolve(result);
        setDefault();
    };
    // TODO: Add `Form` with `validate`.
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(FormDialogServiceContext.Provider, { value: openFormDialog }, children),
        react_1.default.createElement(core_1.Dialog, { open: Boolean(Form), onClose: disableClosingByClickingOutside ? undefined : handleClose, maxWidth: "xl", PaperProps: {
                style: Object.assign(Object.assign(Object.assign({}, styles.dialogStyle), { minWidth }), (isAutoHeight ? styles.autoHeight : {})),
            }, classes: dialogClasses, BackdropComponent: utils_1.CustomBackdrop, BackdropProps: { classes: { root: backdropClasses.backdrop } } }, Form && react_1.default.createElement(Form, { onClose: handleClose, onSubmit: handleSubmit }))));
};
exports.FormDialogServiceProvider = FormDialogServiceProvider;
const styles = {
    dialogStyle: {
        minWidth: 500,
        maxHeight: '50%',
        boxShadow: `0px 4px 10px 6px ${styles_1.colors.black10}`,
        borderRadius: 5,
    },
    autoHeight: {
        maxHeight: '90%',
    },
};
//# sourceMappingURL=FormDialogService.js.map